import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useToast } from "@/context/ToastContext";
import { useAuth } from "@/context/AuthContext";
import { Loader, Currency, Field } from "@/components/Atoms";
import {
  Shield, Users, Crown, Coins, Settings, Wrench, Ban, ScrollText, Map as MapIcon,
  UserCog, Layers, Gift, PackageOpen, Server, Lock, KeyRound, Flame, Calendar,
  Flag, Sparkles, RefreshCw
} from "lucide-react";



export function Reports() {
  const toast = useToast();
  const [data, setData] = useState({ reports: [], count: 0, filter: "pending" });
  const [filter, setFilter] = useState("pending");
  const load = () => api.get(`/admin/reports/list?status=${filter}`).then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); }, [filter]); // eslint-disable-line
  const resolve = async (id) => {
    try { await api.post(`/admin/reports/${id}/resolve`); toast.success("Resolved"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="space-y-4 fade-up" data-testid="reports-tab">
      <div className="glass-card p-4">
        <h3 className="text-lg mb-1" style={{ fontFamily: "'Cinzel Decorative', serif" }}>Player Reports</h3>
        <p className="text-xs text-[var(--muted)]">
          Reports filed by players via the bot's <code>/report</code> command. Mark them resolved when handled.
        </p>
      </div>
      <div className="flex gap-2">
        {["pending", "resolved"].map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`btn btn-sm ${filter === s ? "" : "btn-secondary"}`} data-testid={`reports-filter-${s}`}>
            {s}
          </button>
        ))}
      </div>
      <div className="glass-card p-5" data-testid="reports-list">
        <h3 className="label mb-3">{filter} ({data.count})</h3>
        {data.count === 0 && <p className="text-sm text-[var(--muted)]">No {filter} reports.</p>}
        <ul className="divide-y divide-white/5">
          {data.reports.map((r) => (
            <li key={r.id} className="py-3 flex items-start justify-between gap-3" data-testid={`report-row-${r.id}`}>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium">Report #{r.id} — {r.reported_user}</div>
                <div className="text-xs text-[var(--muted)] mt-1">By {r.reporter_id} · {r.created_at}</div>
                <div className="text-sm mt-2 whitespace-pre-wrap break-words">{r.reason}</div>
                {r.resolved_at && (
                  <div className="text-[10px] text-[var(--teal)] mt-1">Resolved by {r.resolved_by} at {r.resolved_at}</div>
                )}
              </div>
              {filter === "pending" && (
                <button onClick={() => resolve(r.id)} className="btn btn-sm" data-testid={`report-resolve-${r.id}`}>Resolve</button>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
